<template>
  <div>
    <Loader v-if="!organization" />
    <div
      v-else
      :class="{ 'subscribtion-wrapper--accepted': requestSubscription }"
      class="subscribtion-wrapper"
    >
      <div v-if="!requestSubscription" class="subscribtion-wrapper-content">
        <img src="./hourglass.svg" />
        <h1>{{ t('subscribe.title') }}</h1>
        <p>
          {{ t('subscribe.description') }}<span>{{ t('subscribe.link') }}</span>
        </p>
        <Button
          class="Button--primary"
          @click="requestSubscription = !requestSubscription"
        >
          {{ t('subscribe.create') }}
        </Button>
        <Button class="Button--dark" @click="declineSubscription">
          {{ t('subscribe.decline') }}
        </Button>
      </div>
      <div
        v-else
        class="subscribtion-wrapper-content subscribtion-wrapper--accepted-content"
      >
        <h1>{{ t('subscribe.form.title') }}</h1>
        <SubscriptionForm
          :organization="organization"
          @submit="handleOrganizationSubmit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import './style.scss'
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from '@/composables/useI18n'
import SubscriptionForm from '@/forms/SubscriptionForm'
import Loader from '@/components/Loader'
import Button from '@/components/Button'

export default {
  name: 'Subscribe',
  components: {
    Loader,
    Button,
    SubscriptionForm,
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const { t } = useI18n()

    const requestSubscription = ref(false)
    const acceptedTerms = ref(false)

    const organization = computed(() => store.getters.organization)

    const handleOrganizationSubmit = ({ organization }) => {
      store
        .dispatch('saveOrganization', organization)
        .then(() => {
          router.push({ path: 'dashboard' })
        })
        .catch(() => {
          store.dispatch('showFlashMessage', {
            message: t('flash_messages.custom.subscribe_error'),
          })
        })
    }

    const declineSubscription = () => {
      router.push({
        path: '/',
      })
    }

    onMounted(() => {
      store.dispatch('fetchOrganization')
    })

    return {
      requestSubscription,
      acceptedTerms,
      organization,
      handleOrganizationSubmit,
      declineSubscription,
    }
  },
}
</script>
